'use client'
import type { Offer } from '@/utils/offers'
import { isActiveOffer } from '@/utils/offer-inbox'
import styles from './offer-dialog.module.css'

export default function OfferExpiry({ offer, now, countdown = false }: { offer: Offer; now: number; countdown?: boolean }) {
	const expires = new Date(offer.expires_at)
	const remaining = expires.getTime() - now
	if (!Number.isFinite(remaining)) return <p className={styles.hint}>Expiry unavailable</p>
	const active = isActiveOffer(offer, now)
	const expired = offer.state === 'expired' || (offer.state === 'active' && remaining <= 0)
	const minutes = Math.max(1, Math.ceil(remaining / 60_000))
	const seconds = Math.max(0, Math.ceil(remaining / 1000))
	const clock = `${Math.floor(seconds / 86400)}d ${String(Math.floor(seconds / 3600) % 24).padStart(2, '0')}:${String(Math.floor(seconds / 60) % 60).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')} left`
	const timeLeft = countdown ? clock :
		minutes >= 1440
			? `${Math.floor(minutes / 1440)}d ${Math.floor((minutes % 1440) / 60)}h left`
			: minutes >= 60
			? `${Math.floor(minutes / 60)}h ${minutes % 60}m left`
			: remaining < 60_000
			? 'Less than a minute left'
			: `${minutes}m left`
	return (
		<div className={styles.offerExpiry}>
			{active && <strong className={countdown ? styles.liveCountdown : undefined}>{timeLeft}</strong>}
			<span>
				{expired ? 'Expired' : active ? 'Expires' : 'Offer expiry'}{' '}
				<time dateTime={expires.toISOString()}>
					{expires.toLocaleString(undefined, {
						year: 'numeric',
						month: 'short',
						day: 'numeric',
						hour: 'numeric',
						minute: '2-digit',
						timeZoneName: 'short'
					})}
				</time>
			</span>
		</div>
	)
}
